
import React from 'react';

export default function UserInformationPage1() 
{
    return ( 
        <> 
            <div class="row mb-2">
                <div class="col-1">
                    <a href="#"><img class="card-icon" src="./images/user.svg" alt="user lists" border="0"/></a>
                </div>
                <div class="col ms-1">
                    Welcome! This is your User Panel where you have a List of your Lists.
                </div>
            </div>

            <p>Why not just one list? Well, it's about prioritization and privacy. It starts with your Short List that contains a small set of Actions 
               you have prioritized to work on right now. The idea is to move Actions from your private Long List and shared Team Lists to your Short List as you are
               ready for them.</p>
                
            <p>Your private Long List is your personal list of things to do that are waiting to be moved to
               your Short List. Your Long List Actions can not be shared with or viewed by other Users.</p>
            
            <p>Then you have your Team Lists. These Action Lists are intended to be shared within a team of users. These Actions are still 
               private within the approved Team Members but no one else will have access to them.</p>

            <div class="mt-2">
                Enter a new action item above and click "Create" to get started!
            </div>
        </> 
    );
}

/*
 <p>Welcome! This is your, User Panel where you have a List of your Lists.</p>


<em>Intentional Prioritization and recording new Action requests in your lower Lists will help you get things done.</em>
*/